<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-3 sidebar-monitoring bg-custom-blue py-3">

        <!-- Header left sidebar -->
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h4 class="mb-0">{{ $t("views.nav.manageKPISets") }}</h4>
          <button @click="openModal(false, '', 'kpiSet', 'add')" type="button" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#KPISetEditModal">+ {{ $t("general.add") }}</button>
        </div>

        <div class="row mt-4">
          <div class="col-12">
            <div class="d-flex justify-content-between align-items-center">
              <!-- Suchfeld links -->
              <div class="me-3" style="width: 200px">
                <input v-model="searchText" type="text" class="form-control form-control-sm" />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <KPISetTree v-if="'nodes' in kpiSets && kpiSets.nodes.length" :node="kpiSets" :depth="0" mode="manage" :searchText="searchText" :autoOpenDepth="autoOpenDepth" class="mt-2" />
          </div>
        </div>

      </div>
      <div class="col-9 px-5 py-3">
        <div v-if="Object.keys(selectedKPISet).length" class="row">
          <div class="col-12">
            <div class="row">
              <div class="col">
                <button v-if="selectedKPISet.write" @click="openModal(selectedKPISet.id, selectedKPISet.name, 'kpiSet', 'update')" type="button" class="btn btn-sm btn-outline-dark" data-bs-toggle="modal" data-bs-target="#KPISetEditModal">&bull; {{ $t("general.update") }}</button>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col">
                <div class="h4">{{ selectedKPISet.name }}</div>
               </div>
            </div>
            <div class="tab-pane fade show active" id="definition" role="tabpanel">
              <div v-if="selectedKPISet.description" class="mt-3">
                <QuillContent :content="selectedKPISet.description"></QuillContent>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12">
                <div class="card">
                  <div class="card-header fw-bold">{{ $t("views.kpiSet.detail.headingCard") }}</div>
                  <div class="card-body">
                    <ul class="nav nav-tabs border-bottom" role="tablist">
                      <li class="nav-item" role="presentation">
                        <button class="nav-link text-dark active" id="kpis-tab" data-bs-toggle="tab" data-bs-target="#kpis" type="button" role="tab" aria-controls="kpis" aria-selected="false">{{ $t("views.kpiSet.detail.kpiMember") }}
                          <span v-if="selectedKPISet.nodes.length" class="badge bg-primary">{{ selectedKPISet.nodes.length }}</span></button>
                      </li>
                    </ul>
                    <div class="tab-content mt-2">
                      <div class="tab-pane fade show active" id="kpis" role="tabpanel">
                        <div v-if="selectedKPISet.write" class="row my-3">
                          <div class="col">
                            <button @click="openModal(false, '', 'kpi', 'add')" type="button" class="btn btn-sm btn-outline-primary" data-bs-toggle="modal" data-bs-target="#KPISetEditModal">+ {{ $t("general.add") }}</button>
                          </div>
                        </div>
                        <div v-if="selectedKPISet.nodes && selectedKPISet.nodes.length">
                          <table class="table">
                            <thead>
                              <tr class="border-dark">
                                <th scope="col">{{ $t("views.kpiSet.detail.kpiName") }}</th>
                                <th></th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                              <tr v-for="kpi in selectedKPISet.nodes" :key="'kpi' + kpi.id">
                                <td @click="selectedKPISet(kpi.id)" role="button" scope="row" class="fw-normal">{{ kpi.name }}</td>
                                <td><QuillContent :content="kpi.description"></QuillContent></td>
                                <td>
                                  <div class="dropdown">
                                    <a href="#" class="ms-2 text-dark" data-bs-toggle="dropdown">
                                      <svg class="bi" width="28" height="28" fill="currentColor">
                                        <use xlink:href="@/assets/icons/icons.svg#three-dots"/>
                                      </svg>
                                    </a>
                                    <ul class="dropdown-menu">
                                      <li><a @click="openModal(kpi.memberId, 'kpi', 'remove', kpi.name)" class="dropdown-item" href="#KPISetDeleteModal" data-bs-toggle="modal">{{ $t("general.remove") }}</a></li>
                                    </ul>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div v-else class="mt-3 h6">{{ $t("views.kpiSet.detail.noMembers") }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center mt-5">
          <img src="@/assets/img/no_data.svg" class="img-fluid" width="250">
          <p v-if="'nodes' in kpiSets && kpiSets.nodes.length" class="h5 mt-3">{{ $t("views.kpiSet.structure.helpChooseKPISet") }}</p>
          <p v-else class="h5 mt-3">{{ $t("views.kpiSet.structure.helpCreateKPISet") }}</p>
        </div>
        <KPISetEditModal></KPISetEditModal>
        <KPISetDeleteModal></KPISetDeleteModal>
      </div>
    </div>
  </div>
</template>

<script>
import KPISetTree from '@/components/monitoring/KPISetTree.vue'
import KPISetEditModal from '@/components/monitoring/KPISetEditModal.vue'
import KPISetDeleteModal from '@/components/monitoring/KPISetDeleteModal.vue'
import QuillContent from '@/components/QuillContent.vue'
import * as formatUtils from '@/composables/formatUtils'

export default {
  name: 'KPISetManageKPISet',
  data () {
    return {
      KPISetModalElementId: false,
      KPISetModalElementType: '',
      KPISetModalMode: '',
      selectedElement: '',
      searchText: '',
      autoOpenDepth: 2
    }
  },
  components: {
    KPISetTree,
    KPISetEditModal,
    KPISetDeleteModal,
    QuillContent
  },
  computed: {
    sysParms () {
      return this.$store.state.sysParms
    },
    kpiSets () {
      return this.$store.state.kpiSets.constructor === Array ? [] : this.$store.state.kpiSets
    },
    selectedKPISet () {
      return this.$store.state.selectedKPISet
    }
  },

  methods: {
    createLink (type, uuid) {
      let url = ''
      if (type === 'strategy') url = '/strategies/manage/strategies?id=' + uuid
      return url
    },
    openModal (id, name, elementType, mode) {
      if (id) {
        this.KPISetModalElementId = id
      }
      if (name) {
        this.KPISetModalElementName = name.replace(/<[^>]*>/g, '') // Convert name from html to plaintext
      }
      this.KPISetModalElementType = elementType
      this.KPISetModalMode = mode
    },
    formatDate (date) {
      const userLocale = this.$store.state.user.settings?.language
      return formatUtils.formatDate(userLocale, date)
    }
  },

  async created () {
    // check query params for selectedKPISet
    let paramSelectedKPISet = ''
    if (this.$route.query.id) {
      paramSelectedKPISet = this.$route.query.id
    }

    this.$store.commit('SET_LOADING_STATUS', true)
    await this.$store.dispatch('getKPISets')
    if (paramSelectedKPISet !== '') {
      await this.$store.dispatch('getKPISet', { mode: 'view', id: this.selectedKPISet.id })
      this.searchText = this.selectedKPISet.name
    }
    if (Object.keys(this.selectedKPISet).length) {
      await this.$store.dispatch('getKPISet', { mode: 'view', id: this.selectedKPISet.id })
    }
    this.$store.commit('SET_LOADING_STATUS', false)
  }
}
</script>

<style lang="scss" scoped>
.progress-label {
  transform: translate(-50%, -50%);
}
.tab-content .progress {
  margin-top: 6px;
}
</style>
